import { registerWidget, IWidgetDefinition } from '../../common/core';

const styles = require('./fuse-styles.scss').toString();

export const FuseStylesWidgetDefinition: IWidgetDefinition<any, any, any> = {
    init(widget) {
      widget.data = {};
    },
    template: '',
    styles: styles,
  };

registerWidget('fuse-styles', FuseStylesWidgetDefinition);